import { useSelector } from 'react-redux';

import { getGeoState } from './intlModule';

export default function useGeoState() {
  return useSelector(getGeoState);
}
